import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Toaster } from '../toaster.model';
import { Subscription } from 'rxjs';
import { ToasterService } from '../toaster.service';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('200ms ease-in', style({ transform: 'translateY(0%)', opacity: 1 })),
      ]),
      transition(':leave', [animate('200ms ease-in', style({ transform: 'translateY(-100%)', opacity: 0 }))]),
    ]),
  ],
  standalone: false,
})
export class ToasterComponent implements OnInit, OnDestroy {
  @Input() id = 'default';
  @ViewChild('progressbar') progressbar: ElementRef;
  toasts: Toaster[] = [];
  toasterSubscription: Subscription;

  constructor(private toasterService: ToasterService) {}

  ngOnInit(): void {
    this.toasterSubscription = this.toasterService.onToast(this.id).subscribe(toast => {
      if (this.toasts.length >= 4) {
        this.removeToast(this.toasts[0]);
      }
      this.toasts.push(toast);
      // this.setProgressbarWidth(toast);
      setTimeout(() => {
        this.removeToast(toast);
      }, 4000);
    });
  }

  ngOnDestroy() {
    this.toasterSubscription.unsubscribe();
  }

  removeToast(toast: Toaster) {
    this.toasts = this.toasts.filter(x => x !== toast);
  }

  getClass(toast: Toaster) {
    switch (toast.type) {
      case 'success': {
        return 'success';
      }
      case 'alert': {
        return 'warning';
      }
      case 'danger': {
        return 'danger';
      }
      case 'info': {
        return 'info';
      }
      default: {
        return 'default';
      }
    }
  }

  getIcon(toast: Toaster) {
    switch (toast.type) {
      case 'success': {
        return 'thumbsUp';
      }
      case 'alert': {
        return 'attention';
      }
      case 'danger': {
        return 'error';
      }
      case 'info': {
        return 'details';
      }
      default: {
        return 'bell';
      }
    }
  }

  setProgressbarWidth(toast: Toaster) {
    const timer = setInterval(() => {
      toast.progress = toast.progress + 0.3;
      if (toast.progress >= 100) {
        clearInterval(timer);
      }
    }, 10);
  }
}
